import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Button, Container, Row, Col } from 'react-bootstrap';
import { FaPortrait, FaUser, FaSignOutAlt } from 'react-icons/fa';
import '../../styles/components/common/NavBar.css';
import Logout from '../user/Logout';
import { useAuth } from '../../AuthContext';
import SearchBar from './SearchBar';
import AuthModal from '../user/AuthModal';

const NavigationBar = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const dropdownRef = useRef(null);
  const accountRef = useRef(null);
  const logoutRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleDropdownKeyDown = (e) => {
    if (e.key === 'Escape') {
      setDropdownOpen(false);
    } else if (e.key === 'ArrowDown') {
      if (document.activeElement === accountRef.current) {
        logoutRef.current.focus();
      } else {
        accountRef.current.focus();
      }
    } else if (e.key === 'ArrowUp') {
      if (document.activeElement === logoutRef.current) {
        accountRef.current.focus();
      } else {
        logoutRef.current.focus();
      }
    }
  };

  useEffect(() => {
    if (dropdownOpen && accountRef.current) {
      accountRef.current.focus();
    }
  }, [dropdownOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <nav role="navigation" aria-label="Main Navigation">
      <Navbar bg="light" expand="lg" className="shadow-sm">
        <Container>
          <Row className="w-100 align-items-center flex-nowrap">
            <Col xs="auto" className="brand-column d-flex align-items-center">
              <Navbar.Brand as={Link} to="/" className="navbar-brand">
                <img
                  src="/weifinders_logo.svg"
                  alt="WeiFinders Logo"
                  style={{ height: '50px' }}
                />
              </Navbar.Brand>
            </Col>
            <Col className="searchbar-column flex-grow-1 d-flex justify-content-center">
              <SearchBar navigate={navigate} variant="landing" />
            </Col>
            <Col xs="auto" className="profile-column d-flex align-items-center">
              <div ref={dropdownRef} className="profile-dropdown">
                {user ? (
                  <>
                    <Button
                      variant="outline-secondary"
                      className="profile-button"
                      onClick={toggleDropdown}
                      aria-expanded={dropdownOpen}
                      aria-haspopup="true"
                      type="button"
                    >
                      <FaPortrait aria-hidden="true" className="profile-icon" />
                      <span className="status-indicator signed-in"></span>
                    </Button>
                    {dropdownOpen && (
                      <div
                        className="dropdown-menu show"
                        role="menu"
                        onKeyDown={handleDropdownKeyDown}
                      >
                        <div
                          role="menuitem"
                          tabIndex="0"
                          ref={accountRef}
                          className="dropdown-item"
                          onClick={() => {
                            navigate('/account');
                            setDropdownOpen(false);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              navigate('/account');
                              setDropdownOpen(false);
                            }
                          }}
                        >
                          <FaUser aria-hidden="true" style={{ marginRight: '8px' }} />
                          Account
                        </div>
                        <div
                          role="menuitem"
                          tabIndex="0"
                          ref={logoutRef}
                          className="dropdown-item"
                          onClick={() => {
                            setShowLogoutModal(true);
                            setDropdownOpen(false);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              setShowLogoutModal(true);
                              setDropdownOpen(false);
                            }
                          }}
                        >
                          <FaSignOutAlt aria-hidden="true" style={{ marginRight: '8px' }} />
                          Logout
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <AuthModal
                    triggerElement={
                      <Button
                        variant="outline-secondary"
                        className="profile-button"
                        type="button"
                      >
                        <FaPortrait aria-hidden="true" className="profile-icon" />
                        <span className="status-indicator not-signed-in"></span>
                      </Button>
                    }
                  />
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </Navbar>
      <Logout show={showLogoutModal} handleClose={() => setShowLogoutModal(false)} />
    </nav>
  );
};

export default NavigationBar;
